import { Fragment, useEffect, useState } from "react";
import { Text } from "../../FormControls/Text";
import { Stack } from "../../FormControls/Stack";
import { ScreenControl } from "../ScreenControl";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { Input } from "../../FormControls/Input";
import { setCountry } from "../../../../main/slices/userSlice";
import {
  setPos,
  setProcedure,
  loginStore,
  setTokenStore,
  setGroup,
  setStoreName,
  setCountrySrore,
  setCurrencyStore,
  setIdStore,
  setMasterUser
} from "../../../../main/slices/storeSlice";
import { AlertBox } from "../../FormControls/alert";
import { jump } from "../../../../main/slices/routerSlice";
import { ContentPaste } from '@mui/icons-material';
import { COLORS } from '../../../styles/defaults';

export const LoginPos = () => {
  const dispatch = useDispatch();
  const state = useSelector(({ user }) => user);
  const store = useSelector(({ store }) => store);
  const [cookies, setCookies] = useCookies(["source"]);
  const [nextLogin, setNextLogin] = useState("otp");
  
  // ALERT
  const [showAlert, setShowAlert] = useState(false); // view alert
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [alertTitle, setAlertTitle] = useState(null);

  // PASTE CODE
  const handlePaste = async () => {
      try {
          // READ CLIPBOARD
          const copyPos = await navigator.clipboard.readText();
          dispatch(setPos({ value: copyPos, error: false }));
      } catch (err) {
        console.error('invalid action');
      }
  };

  // ACTIVAR BOTON INICIO SESION
  const verifyLogin = async () => {
    return await dispatch(loginStore({
      "origin": "worldpos",
      "wldId": state.idWLD,
      "pos": `R${store.pos.value}`,
    }))
      .unwrap()
      .then(async ({ response }) => {
        if (response.code===200) {
          setNextLogin("pad");
          // setCookies("login", "pad");
          let group= response.data.group;
          let pos= response.data.pos;
          let id= response.data.id;
          let name= response.data.name;
          let currency= response.data.currency;
          let country= response.data.country;
          let isMaster= response.data.master;

          //SETO LOS DATOS DE LA TIENDA
          dispatch(setPos({ value: pos, error: false }));
          dispatch(setMasterUser({ value: isMaster, error: false}))
          dispatch(setIdStore({ value: id, error: false }));
          dispatch(setGroup({value: group, error: false }));
          dispatch(setStoreName({ value: name, error: false }));
          dispatch(setCountrySrore({value: country, error: false }));
          dispatch(setCurrencyStore({ value: currency, error: false }));
          
          //MUESTRO EL PAD
          dispatch(jump({ current: 8, direction: "forward" }))
          return false;
        }
        
        if(response.code===201){
          setNextLogin("otp");
          let token = response.data.token;
          let store = response.data.connect;
          let action = response.data.action;
          dispatch(setTokenStore({value: token, error: false}));
          dispatch(setProcedure({value: action, error: false}));
          dispatch(setIdStore({ value: store, error: false }));
          
          //MUESTRO OTP
          dispatch(jump({ current: 7, direction: "forward" }))
          return false;
        }else {
          //MUESTRO ERROR
          setAlertType('error');
          setAlertMessage(`Comercio invalido, por favor intentalo nuevamente.`);
          setShowAlert(true);
          return false;
        };
      })
      .catch(e => {
        //ERROR DE SERVER
        setAlertType('error');
        setAlertMessage(`Verifica los datos de tu comercio e intentalo nuevamente..`);
        setShowAlert(true);
        return false;
      });
    
    
  }

  //ACTUALIZAR DATOS DEL COMERCIO
  const handleChange = (key, value) => {
    if (key === "pos"){ dispatch(setPos({ value, error: !value })); }
  };

  //CHANGE PAGE
  useEffect(() => {
    dispatch(setProcedure({value: "pad", error: false}));
  }, [nextLogin]);

  const route = () => {
    // FOR THE PATH "phone"
    return { 
      disabled:
        store.pos.error
      };
  };

  // CLOSE ALERT MESSAGE
  const handleCloseAlert = () => setShowAlert(false);

  return (
    <Fragment>
        {/* VIEW ALERT RESPONSE */}
        {showAlert && (
          <AlertBox
            message={`${alertMessage}`}
            type={alertType}
            title={alertTitle}
            onClose={handleCloseAlert}
          />
        )}
        
      <Stack flex={{ flexDirection: "column" }}>
        <div style={{ padding: "0 1.5rem" }}>
          
          {/* CALL TO ACTION */}
          <Text classes={["title", "center"]}> ¡Cobra tus productos con la nueva app Recibe! </Text>        
          
          <div style={{ marginBottom: "3rem" }}></div>
          
          {/* LOGIN */}
          <Text classes={["description"]}>
              Ingresa tu tienda para iniciar sesión
          </Text>

          <Stack 
            style={{
              "display": "flex",
            }}
            flex={{ flexDirection: "row", gap: 15 }}
          > 
            <div 
              style={{ flex: 1 }}>
              <Input
                  classes={[
                    "marginTB1em"
                  ]}
                  attributes={{
                    defaultValue: "R",
                    readOnly: true,
                    // left: "0.6rem",
                    style: { textAlign: "center", paddingRight: "0.5rem" }
                  }}
              />
            </div>
            <div style={{ flex: 12 }}>
              <Input
                  type="number"
                  classes={[
                    "marginTB1em",
                    store.pos.value && store.pos.error,
                  ]}
                  onChange={({ target }) => handleChange("pos", target.value)}
                  placeHolder="Ingresa tu POS"
                  icon={<ContentPaste  style={{"color": COLORS.primary.main}} fontSize="20px" />}
                  onIconClick={() => {handlePaste()}}
              />
            </div>
          </Stack>
        </div>
        <ScreenControl
          btncolor={"cobrarBtn"}
          index={null}
          beforeSubmit={() => verifyLogin()} 
          btnText={"Iniciar"}
          {...route()}
        >
        </ScreenControl>
      </Stack>
    </Fragment>
  );
};
